import type { AuthBootstrapStatus } from "@noiman/shared-auth/auth-bootstrap";

let browserBootstrapApplied = false;
let skipNextAnonymousSessionFetch = false;

/**
 * Hydrate the Better Auth client with the server's credential-presence proof.
 *
 * This module intentionally has no runtime dependency on Better Auth. The root
 * route runs on every page, while the Better Auth UI is only used by the
 * magic-link and passkey routes.
 */
export function primeAuthClientBootstrap(status: AuthBootstrapStatus): void {
  // Server modules are isolate-scoped, so request-specific bootstrap state
  // must never be written there. In the browser this runs once per document.
  if (typeof window === "undefined" || browserBootstrapApplied) return;
  browserBootstrapApplied = true;
  skipNextAnonymousSessionFetch = status === "anonymous";
}

function isBetterAuthSessionGet(
  input: RequestInfo | URL,
  init?: RequestInit,
): boolean {
  const request = typeof Request !== "undefined" && input instanceof Request;
  const method = (
    init?.method ?? (request ? input.method : "GET")
  ).toUpperCase();
  if (method !== "GET") return false;

  const rawUrl = request ? input.url : input.toString();
  try {
    return (
      new URL(rawUrl, "https://auth-bootstrap.invalid").pathname ===
      "/api/auth/get-session"
    );
  } catch {
    return false;
  }
}

export function consumeAnonymousAuthClientBootstrap(
  input: RequestInfo | URL,
  init?: RequestInit,
): boolean {
  if (
    !skipNextAnonymousSessionFetch ||
    !isBetterAuthSessionGet(input, init)
  ) {
    return false;
  }

  skipNextAnonymousSessionFetch = false;
  return true;
}
